import React from "react";
import { Link } from "react-router-dom";
import health_guardian from '../../img/health_guardian.webp';

/**
 * PageTopBar — reusable topbar for inner pages.
 *
 * Props:
 *   links: Array of { label, to?, icon?, onClick?, disabled?, className? }
 *     - to: renders a <Link>
 *     - onClick: renders a <button>
 *     - icon: optional lucide icon component
 *     - disabled: optional, only applies to button variants
 *     - className: optional extra class (e.g. 'danger', 'logout')
 */
export default function PageTopBar({ links = [] }) {
    return (
        <div className="home-topbar">
            <div className="home-topbar-brand">
                <img src={health_guardian} alt="Health Guardian" className="home-topbar-logo" />
                <h1 className="home-topbar-title">Health Guardian</h1>
            </div>
            <div className="home-topbar-actions">
                {links.map(({ label, to, icon: Icon, onClick, disabled, className: cls }) =>
                    to ? (
                        <Link key={label} to={to} className={`topbar-btn ${cls || ''}`.trim()}>
                            {Icon && <Icon size={15} />}
                            <span>{label}</span>
                        </Link>
                    ) : (
                        <button
                            key={label}
                            className={`topbar-btn ${cls || ''}`.trim()}
                            onClick={onClick}
                            disabled={disabled}
                        >
                            {Icon && <Icon size={15} />}
                            <span>{label}</span>
                        </button>
                    )
                )}
            </div>
        </div>
    );
}
